import { CREDIT_ERROR_TIPS } from '~/constants/errors/credit';
import { apiClient } from '~/lib/apiClient';
import { isArcApiError } from '~/src/services/errors';
import {
  OnErrorCallback,
  OnSuccessInstantPaymentCallback,
} from '~/src/services/orders';
import { getGooglePaymentToken } from '~/src/services/orders/paymentHandler/googlePay/paymentToken';
import { OrderDetail } from '~/types/resources/orderDetail';

export type PayByGooglePayInput = {
  totalPrice: string;
  userToken: string;
  orderId: OrderDetail['id'];
  onSuccessCallback: OnSuccessInstantPaymentCallback;
  onErrorCallback: OnErrorCallback;
};

export const payByGooglePay = async (input: PayByGooglePayInput) => {
  const { totalPrice, userToken, orderId, onSuccessCallback, onErrorCallback } =
    input;

  const paymentToken = await getGooglePaymentToken(totalPrice);

  try {
    if (paymentToken == undefined || paymentToken === 'ABORT_BY_USER') {
      throw new Error(paymentToken);
    }

    const encodedToken = Buffer.from(paymentToken).toString('base64');
    const res = await apiClient.v1.orders
      ._orderId(orderId)
      .payments.googlepay.post({
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
        body: {
          token: encodedToken,
        },
      });
    if (res.status == 200) {
      onSuccessCallback(orderId);
    } else {
      if (isArcApiError(res.body)) {
        const errorTips = CREDIT_ERROR_TIPS[res.body.code];
        onErrorCallback(
          'GooglePayでの購入に失敗しました',
          res.body.message,
          errorTips ?? ''
        );
        return;
      }
      throw new Error('GooglePayでの購入に失敗しました');
    }
  } catch (e) {
    console.log(e);
    if (e.message === 'ABORT_BY_USER') {
      onErrorCallback('GooglePayでの購入を中止しました');
      return;
    }
    onErrorCallback('GooglePayでの購入に失敗しました');
  }
};
